import {useCallback, useEffect} from 'react';
import * as React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import {useDispatch, useSelector} from 'react-redux';

import routeByName from '~/constants/routes';
import useModalById from '~/customHooks/useModalById';
import {isProfileCompletedSelector} from '~/modules/CurrentUser/store/selectors';
import {MODAL_GOLD_MEMBERSHIP} from '~/rootStore/modals/modalsIds';
import {breakline} from '~/helpers/htmlCodes';
import {navigateAction, navigateBackAction} from '~/actions/navigateActions';

import ModalBase from '../../ModalBase';
import ModalItem from './components/ModalItem';
import Text from '../../ui/Text';
import {ReactComponent as IconSeenFirst} from './gm-seen-first.svg';
import {ReactComponent as IconMessages} from './gm-messages.svg';
import {ReactComponent as IconGlobeChat} from './gm-globe-chat.svg';

const useStyles = makeStyles(
  (theme) => ({
    wrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: theme.spacing(2),
    },
    illustration: {
      width: '100%',
      height: '100%',
    },
    goldButton: {
      border: 'none',
      background:
        'linear-gradient(102.67deg, #C78D1B 0%, #CF9428 19.27%, #F3C36A 32.29%, #F3C46C 52.08%, #E9B559 71.87%, #CE9326 95.83%)',
    },
  }),
  {name: 'ModalGoldMembership'}
);

const ModalGoldMembership: React.FC = () => {
  const s = useStyles();

  const {isOpen, close, props} = useModalById(MODAL_GOLD_MEMBERSHIP);

  useEffect(() => () => close(), [close]);

  const isProfileCompleted = useSelector(isProfileCompletedSelector);
  const dispatch = useDispatch();
  const handleContinue = useCallback(() => {
    if (isProfileCompleted) {
      dispatch(navigateAction(routeByName.goldMembershipChoose));
    } else {
      dispatch(
        navigateAction(routeByName.createProfile, {
          query: {returnUrl: routeByName.goldMembershipChoose},
        })
      );
    }
    close();
  }, [dispatch, close, isProfileCompleted]);
  const {noNavigateBack} = props as {noNavigateBack: boolean};
  const handleClose = useCallback(() => {
    if (!noNavigateBack) {
      dispatch(navigateBackAction());
    }
    close();
  }, [dispatch, close, noNavigateBack]);

  return (
    <ModalBase
      open={isOpen}
      onClose={handleClose}
      showCloseButton
      contentBelow={
        <Box textAlign="center" p={1}>
          <Text bold color="white" fs="14" lh="18">
            Recurring Payment
          </Text>
          <Text color="white" fs="14" lh="18">
            Payment are recurring every <b>30 days</b>.{breakline}
            You can cancel anytime.
          </Text>
        </Box>
      }
    >
      <div className={s.wrapper}>
        <Box mb={2} textAlign="center">
          <Text fs="18" lh="24">
            Buy Gold Membership for{breakline}
            <b>$9.99/month</b> and get
          </Text>
        </Box>
        <Box width="100%">
          <ModalItem
            title="Unlimited Messages"
            subtitle="Send unlimited messages without interruption"
            icon={<IconMessages />}
          />
          <ModalItem
            title="Chat Around the Globe"
            subtitle="Send non stop messages to users around the globe"
            icon={<IconGlobeChat />}
          />
          <ModalItem
            title="Be Seen First"
            subtitle="Be on top when you send messages"
            icon={<IconSeenFirst />}
          />
        </Box>
        <Box width="100%">
          <Button fullWidth onClick={handleContinue} classes={{root: s.goldButton}}>
            Upgrade to Gold for $9.99/month
          </Button>
        </Box>
      </div>
    </ModalBase>
  );
};

export default ModalGoldMembership;
